export default __webpack_public_path__ + "static/media/close-icon-full.23b23e9a.svg";